import useSettingsStore from "@/store/SettingsStore"
import { syncRootTheme } from "@/utils/themeMethods"
import { useEffect } from "react"

function SourceCodePage() {
  const theme = useSettingsStore(state => state.theme)
  useEffect(() => {
    syncRootTheme(theme)
  }, [theme])
  return (
    <div className="h-screen w-screen relative bg-zinc-300 text-zinc-800 dark:bg-zinc-800 dark:text-zinc-300">
      <div className="h-full flex flex-col justify-center items-center">
        <h1 className="text-2xl font-semibold">Do you want Source Code?</h1>
        <p className="text-lg">You can Copy this UI and make this app yourself bcz this repo is private.</p>
        <p className="text-base">So projects khud se banao :&#41;</p>
      </div>
      <p className="absolute bottom-0 right-0 text-base text-zinc-500 dark:text-zinc-600">Maybe you can get source code by simply contacting me?</p>
    </div>
  )
}

export default SourceCodePage